export default __webpack_public_path__ + "static/media/hope-skip-drive.fa0ea102.png";